import { render } from "./MyProfileSettings.vue?vue&type=template&id=2a75a7d8"
import script from "./MyProfileSettings.vue?vue&type=script&lang=js"
export * from "./MyProfileSettings.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__